export const environment = {
  production: true,
  appVersion: require("../../package.json").version + " |",
  // apiUrl: "https://api-lease.almamoon.sa/api/",
  apiUrl: "https://api-lease-uat.almamoon.sa/api/",
  logosUrl: "https://o-lease-api.oasisoft.net/logo/",
  SaudiVatPercentage: 0.15,
};
